import { render, staticRenderFns } from "./AudienceList__ColumnProperty.vue?vue&type=template&id=e81b1902&scoped=true&"
import script from "./AudienceList__ColumnProperty.vue?vue&type=script&lang=js&"
export * from "./AudienceList__ColumnProperty.vue?vue&type=script&lang=js&"
import style0 from "./AudienceList__ColumnProperty.vue?vue&type=style&index=0&id=e81b1902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81b1902",
  null
  
)

export default component.exports